module.exports = __webpack_public_path__ + "cidades-para-pessoas--76cf14be.png";


//////////////////
// WEBPACK FOOTER
// ./_source/img/parceiros/cidades-para-pessoas.png
// module id = 236
// module chunks = 0